import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import EditSubscription from './components/EditSubscription';
import SubscriptionList from './components/SubscriptionList';

const Subscriptions = () => {
  const [listRequiresReload, setListRequiresReload] = useState(true);
  const [editSubscriptionId, setEditSubscriptionId] = useState();
  const setEditSubscriptionIdHandler = (subscription_id) => setEditSubscriptionId(subscription_id);

  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Organizations Subscription Management</h3>
          <h3 className="page-subhead subhead">Manage workspace organizations subscription</h3>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <SubscriptionList setEditSubscriptionIdHandler={setEditSubscriptionIdHandler} setListRequiresReload={setListRequiresReload} listRequiresReload={listRequiresReload}/>
        </Col>
        <Col md={4}>
          <EditSubscription subscription_id={editSubscriptionId} setListRequiresReload={setListRequiresReload} setEditOrganizationIdHandler={setEditSubscriptionIdHandler}/>
        </Col>
      </Row>
    </Container>
  );
};

export default Subscriptions;